import * as paths from "../../../constants/paths";
import { initials } from "../../../helpers/helpers";

/**
 * The company detail hero.
 *
 * Monogram and name side by side, no logo and no description - the same
 * rules the directory card follows. Logos exist for a few hundred companies
 * out of sixty thousand and descriptions for fewer still, so both produced a
 * page that looked complete for the handful we had curated and broken for
 * everyone else. Initials are always available and always consistent.
 *
 * The facts that survive are the ones we hold for every employer we list:
 * where they are, how big, when founded, their site, and the sponsorship
 * badges. Anything blank simply does not render.
 */
export default function TopBlock({ company }) {
  const facts = [
    { icon: "map_marker", value: company?.location },
    { icon: "group", value: company?.employees },
    {
      icon: "calendar",
      value: company?.founded ? `Founded in ${company.founded}` : null,
    },
  ].filter((f) => f.value);

  return (
    <div className="top_block">
      <div className="contain">
        <div className="inner">
          {/* The monogram sits in the slot the logo tile used to occupy, and
              the name stays inside .text .heading. The styling in this file
              is written as deep descendant selectors - .top_block .text
              .heading .sponsor_tag img is what keeps the Active Sponsor star
              at 1.2rem - so markup moved out of that path silently loses it.
              Changing what is in the slot is safe; changing the structure is
              not. */}
          <div className="icon monogram_icon" aria-hidden="true">
            {initials(company?.name)}
          </div>

          <div className="text">
            <div className="heading h4 m-0">
              {company?.name}
              {company?.sponsorType}
              {company?.verified && (
                <div className="verified_badge">Verified</div>
              )}
            </div>

            <ul className="mini_list">
              {facts.map((f) => (
                <li key={f.icon}>
                  <img
                    src={`${paths.SITE_BASE_URL}/images/icon_mini_${f.icon}.png`}
                    alt=""
                  />
                  {f.value}
                </li>
              ))}
              {company?.website && (
                <li>
                  <img
                    src={paths.SITE_BASE_URL + "/images/icon_mini_internet.png"}
                    alt=""
                  />
                  <a href={company.website} target="_blank" rel="noreferrer">
                    {company.website}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
